import React from "react";
import { CalendarCheck, Sparkles, MessageSquareText, Coffee, Compass } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function WhyAcVanDijk() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const features = [{
    title: "Favo Drank",
    description: "Koffie. Altijd koffie. Een flat white voor Wesley, een cappuccino voor Priscilla. Op vakantie ruilen we de strandstoel in voor een zoektocht naar het beste koffietentje in de stad. Want goede koffie is geen bijzaak, het is een belevenis.",
    icon: Coffee
  }, {
    title: "Bucket List",
    description: "Levensgenieten en uitdagingen opzoeken, dat zit in ons DNA. Zowel op werkgebied als in het leven zelf. Van een eerste les reformer pilates samen tot ooit die wereldreis maken. Want wie stilstaat groeit niet. En dat geldt net zo goed buiten kantoor.",
    icon: Compass
  }, {
    title: "Favo Tool",
    description: "Claude & ChatGPT. Maar dan wel op de juiste manier. Een AI-tool is zo krachtig als de mens erachter. Wij geloven dat je jezelf en de tool in zijn kracht moet zetten om resultaat te boeken. Dat is het verschil tussen AI gebruiken en AI beheersen.",
    icon: Sparkles
  }];
  return <section data-section-id="42523" id="onze-cultuur" className="py-20 !bg-[hsl(218,50%,9%)] !text-[hsl(45,73%,96%)] md:py-28">
      <div className="container mx-auto px-4">
        <div ref={ref} className={cn("transition-all duration-1000 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-3xl font-default font-bold mb-6 tracking-tight !bg-transparent !text-[hsl(250,75%,67%)] md:text-5xl">Dit zijn wij ook</h2>
            <p className="text-lg leading-relaxed font-sans !text-[hsl(44,48%,95%)]">Want achter Connected Online zitten gewoon twee mensen met een passie voor ondernemen, koffie en het leven zelf. Elkaars tegenpolen, maar precies daarom compleet. Samen houden we elkaar scherp, vullen we elkaar aan en bouwen we elke dag met plezier aan jouw groei.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {features.map((feature, i) => <Card key={i} data-index={i} className="flex flex-col gap-6 py-6 border border-border/50 shadow-sm bg-card/40 backdrop-blur-md transition-all duration-500 text-center h-full rounded-2xl !opacity-[1] !text-transparent hover:bg-card hover:shadow-xl">
                <CardHeader className="flex flex-col items-center pt-10 pb-4">
                  <div className="mb-6 p-4 rounded-full bg-accent text-accent-foreground ring-1 ring-accent/20 flex items-center justify-center transition-transform duration-300 hover:scale-110">
                    <feature.icon className="w-8 h-8" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="text-xl font-default font-bold text-primary">
                    {feature.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="pb-10">
                  <CardDescription className="text-base text-muted-foreground leading-relaxed font-sans">
                    {feature.description}
                  </CardDescription>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </div>
    </section>;
}